<app-navbar></app-navbar>

<div class="payment-success-container">
  <div class="result-card">
    <!-- Loading State -->
    @if (isLoading) {
      <div class="loading-state">
        <div class="spinner"></div>
        <h2>Verificando el estado de tu pago...</h2>
        <p>Por favor espera mientras confirmamos tu transacción.</p>
      </div>
    }

    <!-- Error State -->
    @if (error && !isLoading) {
      <div class="error-state">
        <div class="icon-container error">
          <i class="fas fa-exclamation-triangle"></i>
        </div>
        <h2>Problema con la verificación</h2>
        <p class="error-message">{{ error }}</p>
        
        <div class="action-buttons">
          <button class="btn btn-primary" (click)="goToReservations()">
            <i class="fas fa-list"></i>
            Ver Mis Reservas
          </button>
          <button class="btn btn-secondary" (click)="goToHome()">
            <i class="fas fa-home"></i>
            Ir a Inicio
          </button>
        </div>
      </div>
    }

    <!-- Success State -->
    @if (paymentDetails && !error && !isLoading) {
      <div class="success-state">
        <div class="icon-container success">
          <i class="fas fa-check-circle"></i>
        </div>
        
        @if (paymentDetails.payment?.status === 'Pagado') {
          <h2>¡Pago Exitoso!</h2>
          <p class="success-message">Tu reserva ha sido confirmada exitosamente.</p>
        } @else {
          <h2>Pago en Proceso</h2>
          <p class="warning-message">Tu pago está siendo procesado. Te notificaremos cuando esté confirmado.</p>
        }

        <div class="payment-details">
          <h3>Detalles del Pago</h3>
          <div class="detail-row">
            <span class="label">ID de Reserva:</span>
            <span class="value">{{ reservation_id }}</span>
          </div>
          @if (payment_id) {
            <div class="detail-row">
              <span class="label">ID de Pago MercadoPago:</span>
              <span class="value">{{ payment_id }}</span>
            </div>
          }
          @if (paymentDetails.payment?.mp_payment_id) {
            <div class="detail-row">
              <span class="label">ID de Pago (Backend):</span>
              <span class="value">{{ paymentDetails.payment.mp_payment_id }}</span>
            </div>
          }
          @if (paymentDetails.payment?.status) {
            <div class="detail-row">
              <span class="label">Estado:</span>
              <span class="value status" [class]="paymentDetails.payment.status === 'Pagado' ? 'paid' : 'pending'">
                {{ paymentDetails.payment.status }}
              </span>
            </div>
          } @else {
            <div class="detail-row debug-info">
              <span class="label">⚠️ Debug Info:</span>
              <span class="value">Status no disponible - {{ paymentDetails | json }}</span>
            </div>
          }
          @if (paymentDetails.payment?.status_description) {
            <div class="detail-row">
              <span class="label">Método de Pago:</span>
              <span class="value">{{ paymentDetails.payment.status_description }}</span>
            </div>
          }
          @if (paymentDetails.payment?.amount) {
            <div class="detail-row">
              <span class="label">Monto:</span>
              <span class="value">${{ paymentDetails.payment.amount }}</span>
            </div>
          }
        </div>

        <div class="next-steps">
          <h3>Próximos Pasos</h3>
          <ul>
            @if (paymentDetails.payment?.status === 'Pagado') {
              <li><i class="fas fa-envelope"></i> Recibirás un email de confirmación con los detalles de tu reserva</li>
              <li><i class="fas fa-calendar"></i> Puedes ver todos los detalles en tu dashboard de reservas</li>
              <li><i class="fas fa-phone"></i> Si tienes preguntas, no dudes en contactarnos</li>
            } @else {
              <li><i class="fas fa-clock"></i> El pago puede tardar unos minutos en procesarse</li>
              <li><i class="fas fa-refresh"></i> Puedes verificar el estado desde tu dashboard</li>
              <li><i class="fas fa-envelope"></i> Te notificaremos por email cuando se confirme</li>
            }
          </ul>
        </div>

        <div class="action-buttons">
          <button class="btn btn-primary" (click)="goToReservations()">
            <i class="fas fa-list"></i>
            Ver Mis Reservas
          </button>
          <button class="btn btn-secondary" (click)="goToHome()">
            <i class="fas fa-home"></i>
            Ir a Inicio
          </button>
        </div>
      </div>
    }
  </div>
</div>

<app-footer></app-footer>
